export const alphabeticalSort = (a: string, b: string) => a.localeCompare(b);

export const numericSort = (a: number, b: number) => a - b;
